export const normalizeQuery = (value, maxLength = 80) => {
    let normalized = String(value ?? '');

    try {
        normalized = normalized.normalize('NFKC');
    } catch {
        // Older browsers can search without Unicode normalization.
    }

    normalized = normalized.replace(/\s+/gu, ' ').trim();

    return [...normalized].slice(0, Math.max(0, maxLength)).join('');
};

export const createSearchRequestUrl = (endpoint, query, limit, baseUrl = 'http://localhost/') => {
    const url = new URL(endpoint, baseUrl);
    url.searchParams.set('q', normalizeQuery(query));
    url.searchParams.set('limit', String(Math.max(1, Number.parseInt(limit, 10) || 1)));

    return url.toString();
};

export const createSearchResultsUrl = (action, query, baseUrl = 'http://localhost/') => {
    const url = new URL(action || '/', baseUrl);
    url.searchParams.set('s', normalizeQuery(query));
    url.searchParams.set('post_type', 'product');

    return url.toString();
};

export const getSearchProgress = (query, maxLength = 80) => {
    const length = [...normalizeQuery(query, maxLength)].length;

    if (length === 0) {
        return 0;
    }

    return Math.min(100, Math.max(8, Math.round((length / Math.max(1, maxLength)) * 100)));
};

export const isEditableTarget = (target) => {
    if (!target || typeof target !== 'object') {
        return false;
    }

    const tagName = String(target.tagName || '').toLowerCase();

    return ['input', 'textarea', 'select'].includes(tagName) || Boolean(target.isContentEditable);
};

export const isSearchShortcut = (event) => {
    if (!event || event.defaultPrevented || event.isComposing || event.altKey) {
        return false;
    }

    const key = String(event.key || '').toLowerCase();
    const commandK = key === 'k' && (event.metaKey || event.ctrlKey);
    const slash = key === '/' && !event.metaKey && !event.ctrlKey && !isEditableTarget(event.target);

    return commandK || slash;
};

export const isAbortError = (error) =>
    Boolean(error && (error.name === 'AbortError' || error.code === 20));
